@if (injuries) {
    <div class="d-flex table-scrollable">
        <div class="flex-grow-1">
            <table class="table-scrollable__data__table" data-cy="app-table-left-data">
                <thead>
                    <tr>
                        @if (showParticipant) {
                            <th class="table-scrollable__table-th" colspan="2">
                                {{ 'web.team' | translate }}
                            </th>
                        }
                        @if (showPlayer) {
                            <th class="table-scrollable__table-th" colspan="2">
                                {{ 'web.player' | translate }}
                            </th>
                        }
                        <th class="table-scrollable__table-th">
                            {{ 'web.injury' | translate }}
                        </th>
                        <th class="table-scrollable__table-th">
                            {{ 'web.status' | translate }}
                        </th>
                        @if (showPracticeStatus) {
                            <th class="table-scrollable__table-th">
                                {{ 'web.practice_status' | translate }}
                            </th>
                        }
                        <th class="table-scrollable__table-th" style="width: 16px"></th>
                    </tr>
                </thead>
                <tbody>
                    @for (injuryData of injuries; track $index) {
                        <tr class="table-scrollable__table-row">
                            @if (showParticipant) {
                                <td class="table-scrollable__table-td text-center">
                                    @if (injuryData.participant.image !== null) {
                                        <img
                                            [src]="injuryData.participant.image"
                                            [alt]="injuryData.participant.name"
                                            height="40"
                                            width="40"
                                            style="object-fit: contain"
                                            class="mr-1"
                                        />
                                    }
                                    @if (injuryData.participant.image === null) {
                                        <img
                                            [src]="'/img/sports/' + sportName + '.png'"
                                            [alt]="injuryData.participant.name"
                                            height="40"
                                            width="40"
                                            style="object-fit: contain"
                                            class="mr-1"
                                        />
                                    }
                                </td>
                            }
                            @if (showParticipant) {
                                <td class="table-scrollable__table-td">
                                    <a
                                        [routerLink]="[
                                            '/page/sport/participant',
                                            sportName + '-' + sportId,
                                            injuryData.participant.id,
                                        ]"
                                        class="text-reset table-scrollable-team"
                                    >
                                        {{ injuryData.participant.name }}
                                    </a>
                                </td>
                            }
                            @if (showPlayer) {
                                <td class="table-scrollable__table-td text-center">
                                    <div class="img-circle img-circle--40 mr-3 rounded-circle">
                                        <img
                                            (error)="imageError($event, 'avatar')"
                                            [attr.alt]="injuryData.player.name"
                                            [src]="'/assets/players/photos/' + injuryData.player.id + '.png'"
                                            height="40"
                                            loading="lazy"
                                        />
                                    </div>
                                </td>
                            }
                            @if (showPlayer) {
                                <td class="table-scrollable__table-td">
                                    <a
                                        [routerLink]="[
                                            '/page/sport/player',
                                            sportName + '-' + sportId,
                                            injuryData.player.id,
                                        ]"
                                        class="text-reset table-scrollable-team"
                                    >
                                        {{ injuryData.player.name }}
                                    </a>
                                </td>
                            }
                            <td class="table-scrollable__table-td">
                                {{ injuryData.primary }}
                                @if (injuryData.secondary !== null) {
                                    , {{ injuryData.secondary }}
                                }
                            </td>
                            <td class="table-scrollable__table-td">
                                {{ injuryData.status }}
                            </td>
                            @if (showPracticeStatus) {
                                <td class="table-scrollable__table-td">
                                    {{ injuryData.practice_status }}
                                </td>
                            }
                            @if (injuryData.comment) {
                                <td
                                    class="table-scrollable__table-td"
                                    data-placement="top"
                                    data-toggle="tooltip"
                                    title="{{ injuryData.comment }}"
                                >
                                    <i class="fa fa-info-circle info-icon"></i>
                                </td>
                            }
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
} @else {
    <app-placeholder-table></app-placeholder-table>
}
@if (injuries?.length === 0) {
    <div class="text-center">
        <strong>{{ 'web.no_data_found' | translate }}</strong>
    </div>
}
